import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import ForgotPassword from "subscreens/general/forgot-password/forgotPassword";
import AppContext from "context/AppContext";

const SellerForgotPassword = () => {
    const { baseUrl, Navigate } = useContext(AppContext);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");


    const SellerForgotPassword = () => {
        if (!email.trim()) {
            setError("Email address is required.");
            return;
        }
        setError("");
        setLoading(true);
        axios.post(`${baseUrl}/seller/otp/forgotPassword`, {
            email: email.trim()
        })
            .then((response) => {
                console.log(response.data)
                setLoading(false);
                Swal.fire({
                    icon: "success",
                    title: "OTP Sent",
                    text: "OTP has been sent to your email.",
                    confirmButtonColor: "#000000"
                });
                Navigate("/seller/otpverification", {
                    state: {
                        email: email,
                        from: "forgot-password",
                    },
                });
            })
            .catch((error) => {
                setLoading(false);
                const message =
                    error?.response?.data?.message ||
                    "Something went wrong.";
                setError(message);
                Swal.fire({
                    icon: "error",
                    title: "Request Failed",
                    text: message,
                    confirmButtonColor: "#000000"
                });
            });
    };

    return (
        <ForgotPassword
            userType="seller"
            loginPath="/seller/login"
            onSubmit={SellerForgotPassword}
            email={email}
            setEmail={setEmail}
            loading={loading}
            error={error}
        />
    );
};

export default SellerForgotPassword;